module.exports = __webpack_public_path__ + "img/light-gray.fc50543d.svg";